module.exports = __webpack_public_path__ + "img/gagc4680_1.423c1ad4.svg";